import { eLinkType } from "./api/enums";
import { ITlfItemRelationship, TlfItemIndexReadDto } from "./api/tlfItem/TlfItemIndexReadDto";
import { TlfItemReadDto } from "./api/tlfItem/TlfItemReadDto";

/**
 * Gets the preferred "Based On" relationship for a TLF item.
 *
 * If multiple "Based On" relationships exist, a relationship with a
 * status of `Valid` is preferred. If no valid relationship exists,
 * the first "Based On" relationship is returned.
 *
 * @param tlfItem - The TLF item containing relationship information
 * @returns The preferred "Based On" relationship, or `undefined` if none exists
 */
export const getBasedOnRelationship = (
  tlfItem?: TlfItemReadDto | TlfItemIndexReadDto | null,
): ITlfItemRelationship | undefined => {
  const basedOnLinks =
    tlfItem?.relationships?.filter((r) => r.linkType === eLinkType.BasedOn) ?? [];
  if (basedOnLinks.length === 0) {
    return undefined;
  }

  return basedOnLinks.at(-1);
};
